import { lazy } from 'react'
import { createBrowserRouter, Outlet, type RouteObject } from 'react-router-dom'
import { ProjectFormProvider } from '@/context/ProjectFormContext'

import AuthLogin from '@/views/auth'
import ShortUrlRedirect from '@/views/short-url-redirect'

// 遅延読み込み
const Response = lazy(() => import('@/views/response'))

/** 同一プロジェクトのフォームを Context で取得し、子ルートに渡すレイアウト */
function ProjectFormLayout() {
  return (
    <ProjectFormProvider>
      <Outlet />
    </ProjectFormProvider>
  )
}

const NotFound = () => (
  <div style={{ padding: '24px', textAlign: 'center' }}>
    <h1 style={{ fontSize: '24px', marginBottom: '8px' }}>404</h1>
    <p>ページが見つかりません。</p>
  </div>
)

// 認証・回答ルート（プロジェクトフォームを Context で共有）
// ログイン: login/学校ID/プロジェクトID
// 回答: response/学校ID/プロジェクトID/事業者ID
const projectRoutes: RouteObject[] = [
  {
    path: '/login/:schoolId/:projectId',
    element: <ProjectFormLayout />,
    children: [{ index: true, element: <AuthLogin /> }],
  },
  {
    path: '/response/:schoolId/:projectId/:managementId',
    element: <ProjectFormLayout />,
    children: [{ index: true, element: <Response /> }],
  },
]

// ルート未指定・不正パスは 404
export const notSignInRoutes: RouteObject[] = [
  {
    path: '/',
    element: <NotFound />,
  },
  {
    path: '/login',
    element: <NotFound />,
  },
  { path: '/s/:code', element: <ShortUrlRedirect /> },
  ...projectRoutes,
]

// 全体ルート
export const routes: RouteObject[] = [
  ...notSignInRoutes,
  {
    path: '*',
    element: <NotFound />,
  },
]

export const router = createBrowserRouter(routes)

